import React, { FC } from 'react';
import { observer } from 'mobx-react';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';

import EnhancedTableToolbar from './EnhancedTableToolbar';
import EnhancedTableHead from './EnhancedTableHead';
import EnhancedTableBody from './EnhancedTableBody';

import useAccountsPayableCustomTable from './useAccountsPayableCustomTable';
import useStyles from './styles';

export interface IAccountsPayableCustomTable {
  group?: string;
  grouped?: boolean;
  groupedTotalRows?: number;
  groupedRowsIds?: string[];
  canSelect?: boolean;
  toolBarTitle?: string;
  isInProcess?: boolean;
  rows: any[];
  statusSuccessLabel?: string;
  statusErrorLabel?: string;
  hideEnhancedTableToolbar?: boolean;
  isCanceled?: boolean;
  autoRefreshTotals?: boolean;
}

const AccountsPayableCustomTable: FC<IAccountsPayableCustomTable> = ({
  group = '',
  grouped = false,
  groupedRowsIds = [],
  groupedTotalRows = 0,
  canSelect = true,
  isInProcess = false,
  hideEnhancedTableToolbar = false,
  isCanceled = false,
  autoRefreshTotals = false,
  toolBarTitle = '',
  rows,
  statusSuccessLabel = 'Listo para procesar',
  statusErrorLabel = 'No se puede procesar',
}) => {
  const classes = useStyles({ grouped });

  const {
    headCells,
    totalVisibleColumns,
    handleSelectAllClick,
    handleClick,
    isSelected,
    handleGetSelectedIdsLength,
    totalAmount,
    getToolsSelectedColumnsLength,
  } = useAccountsPayableCustomTable({
    grouped,
    groupedRowsIds,
    rows,
    autoRefreshTotals,
    groupedTotalRows,
  });

  return (
    <Grid container className={classes.container}>
      <Accordion
        style={{ borderRadius: '10px' }}
        disabled={!grouped}
        expanded={grouped ? undefined : true}
        elevation={0}
        className={classes.accordionContainer}
      >
        {!hideEnhancedTableToolbar && (
          <EnhancedTableToolbar
            numSelected={handleGetSelectedIdsLength()}
            rowCount={!grouped ? rows.length : groupedTotalRows}
            totalAmount={totalAmount}
            group={group}
            canSelect={canSelect}
            toolBarTitle={toolBarTitle}
            isInProcess={isInProcess}
          />
        )}
        <AccordionDetails className={classes.accordionDetailsContainer}>
          <TableContainer>
            <Table
              key={getToolsSelectedColumnsLength}
              className={classes.table}
              aria-labelledby="tableTitle"
              size={'medium'}
              aria-label="enhanced table"
              style={{ width: '100%', tableLayout: 'auto' }}
            >
              <EnhancedTableHead
                headCells={headCells}
                classes={classes}
                numSelected={handleGetSelectedIdsLength()}
                onSelectAllClick={handleSelectAllClick}
                rowCount={!grouped ? rows.length : groupedTotalRows}
                grouped={grouped}
                totalVisibleColumns={totalVisibleColumns}
                canSelect={canSelect}
              />
              <EnhancedTableBody
                grouped={grouped}
                isCanceled={isCanceled}
                canSelect={canSelect}
                isInProcess={isInProcess}
                rows={rows}
                isSelected={isSelected}
                handleClick={handleClick}
                headCells={headCells}
                statusErrorLabel={statusErrorLabel}
                statusSuccessLabel={statusSuccessLabel}
                totalVisibleColumns={totalVisibleColumns}
              />
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default observer(AccountsPayableCustomTable);
